/* Petsofy motion layer: scroll progress bar + scroll-reveal with stagger.
   No dependencies. Does nothing for visitors who prefer reduced motion. */
(function () {
  var doc = document;
  var root = doc.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  root.classList.add('pz-js');

  function start() {
    /* ---- scroll progress bar ---- */
    var bar = doc.createElement('div');
    bar.id = 'pz-progress';
    bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = root.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();

    /* ---- scroll reveal ---- */
    // Elements the theme does not already animate itself (it fades its own `.scroll-animate` blocks in).
    var SELECTORS = [
      '[class*="ai-round-offer-list__item"]',
      '.feature-row',
      '.feature-cards__item',
      '.collection-grid-item',
      '.site-footer__content > *',
      '.product__info-container',
      'media-gallery',
      'main .rte > *',
      '.page-width > .rich-text__content > *'
    ];
    var items = [];
    SELECTORS.forEach(function (sel) {
      doc.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.scroll-animate') || el.classList.contains('pz-reveal')) return;
        if (el.closest('[hidden], .drawer, .menu-drawer-container')) return;
        items.push(el);
      });
    });
    var perParent = new Map();
    items.forEach(function (el) {
      var p = el.parentElement;
      var n = perParent.get(p) || 0;
      perParent.set(p, n + 1);
      el.style.setProperty('--pzd', Math.min(n, 6) * 90 + 'ms');
      el.classList.add('pz-reveal');
      if (/round-offer-list__item/.test(el.className)) el.classList.add('pz-reveal--zoom');
    });

    var lines = [].slice.call(doc.querySelectorAll('.section__header'));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pz-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.concat(lines).forEach(function (el) { io.observe(el); });

    // Fail-safe: never leave content hidden if the observer is delayed.
    window.setTimeout(function () {
      items.concat(lines).forEach(function (el) { el.classList.add('pz-in'); });
    }, 7000);
  }

  if (doc.body) start(); else doc.addEventListener('DOMContentLoaded', start);
})();
